import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const updateFastShippingCopyMeganavLGSelector = createSelector(
    testTargetOffersSelector,
    offers => offers.updateFastShippingCopyMeganavLG || Empty.Object
);

export { updateFastShippingCopyMeganavLGSelector };
